export default "__VITE_ASSET__e41T3k5i__"